import { Icon } from '@pixum/icon';
import Text, { TEXT_VARIANT } from '@pixum/text';
import { TextInput } from '@pixum/web-input';
import Button, { ButtonVariants } from '@pixum/button';
import { DeleteIcon } from '@pixum/svg-icon';
import styles from './CartVoucher.module.css';

const ACCORDION_STATE_OPEN = 'open';
const ACCORDION_STATE_CLOSED = 'closed';

interface ActiveVoucherProps {
  activeVoucher: string;
  isOpen: boolean;
  isRemoving: boolean;
  onAccordionClick: () => void;
  removeFormAction: (formData: FormData) => void;
  constants: {
    headlineText: string;
    activeText: string;
    removeButtonText: string;
  };
}

export function ActiveVoucher({
  activeVoucher,
  isOpen,
  isRemoving,
  onAccordionClick,
  removeFormAction,
  constants,
}: ActiveVoucherProps) {
  return (
    <div className={styles.container}>
      <button
        type="button"
        onClick={onAccordionClick}
        className={styles.accordionButton}
        aria-expanded={isOpen}
        aria-controls="active-voucher-form"
      >
        <Text variant={TEXT_VARIANT.HEADLINE}>{constants.headlineText}</Text>
        <Icon name="chevron-right" />
      </button>

      <div className={styles.formWrapper} data-state={isOpen ? ACCORDION_STATE_OPEN : ACCORDION_STATE_CLOSED}>
        <form id="active-voucher-form" action={removeFormAction} className={styles.form}>
          <input type="hidden" name="code" value={activeVoucher} />
          <div className={styles.voucherInputWrapper}>
            <Text variant={TEXT_VARIANT.CAPTION}>{constants.activeText}</Text>
            <TextInput disabled={true} value={activeVoucher} />
          </div>

          <Button
            className={styles.submitButton}
            variant={ButtonVariants.SECONDARY}
            isBusy={isRemoving}
            disabled={isRemoving}
          >
            <DeleteIcon />
            <span>{constants.removeButtonText}</span>
          </Button>
        </form>
      </div>
    </div>
  );
}
